(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-badge"]) return;
  try {
    
  class CookieBadge extends HTMLElement {
    constructor() {
      super();
      this.cookieName = 'hide-overlay-badge';
      this.closeButton = document.getElementById('cookie-badge-close');
    }

    connectedCallback() {
      if (this.getCookie(this.cookieName)) {
        // Cookie exists, stop script
        return;
      }

      this.show();

      // Add event listener
      this.closeButton.addEventListener('click', this.disableBadge.bind(this));
    }

    disconnectedCallback() {
      // Remove event listener
      this.closeButton.removeEventListener('click', this.disableBadge.bind(this));
    }

    show() {
      this.style.display = '';
    }

    hide() {
      this.remove();
    }

    disableBadge() {
      this.setCookie(this.cookieName, '1', this.dataset.cookieLength);
      this.hide();
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
  }

  customElements.define('cookie-badge', CookieBadge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const scrollThreshold = 15;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      this.handlePreventRevealEvent = (event) => {
        this.preventReveal = event && event.detail && event.detail.prevent;
      };

      this.addEventListener('preventHeaderReveal', this.handlePreventRevealEvent);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const diff = this.currentScrollTop - scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && diff > scrollThreshold && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop <= this.header.offsetHeight) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = this.header.offsetHeight;
      if (scrollTop >= headerHeight) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-rod"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
  class ProductHighlights extends SliderComponent {
    constructor() {
      super();

      this.slideTimeout = null;
      this.fadeTimeout = null;
      this.transformTimeout2 = null;
      this.transformTimeout3 = null;
      this.defaultDuration = 1000;
      this.container = this.querySelector('.product-highlights-container');
      this.image = document.getElementById('product-highlight-image');

      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      if (!this.sliderControlWrapper) return;

      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();

      this.setHeight();
    }

    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');

      if (!this.sliderControlButtons.length) return;

      this.sliderControlButtons.forEach((link) => {
        link.classList.remove('--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }

    linkToSlide(event) {
      event.preventDefault();
      const position = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
      this.loadPage(position);

      // Scroll to marker
      const scrollTarget = this.container.querySelector(`[data-position="${position}"]`);
      scrollTarget.scrollIntoView();
    }

    loadPage(position) {
      clearTimeout(this.slideTimeout);
      clearTimeout(this.fadeTimeout);
      clearTimeout(this.transformTimeout2);
      clearTimeout(this.transformTimeout3);

      if (position == this.currentPage || position < 1 || position > this.sliderItemsToShow.length) return;

      // Set transform and duration values
      const data = window.product_highlights_data[position - 1];
      this.transformImage(data);

      // Scroll slideshow
      const slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (position - this.currentPage);
      this.slider.classList.add('tw-opacity-0');

      this.slideTimeout = setTimeout(
        function () {
          this.slider.scrollTo({
            left: slideScrollPosition,
          });
        }.bind(this),
        500
      );

      this.fadeTimeout = setTimeout(
        function () {
          this.slider.classList.remove('tw-opacity-0');
        }.bind(this),
        500
      );
    }

    transformImage(data) {
      if (data) {
        if (data.transform1) {
          this.image.style.transitionDuration = data.duration1 ? data.duration1 + 'ms' : '';
          this.image.style.transform = data.transform1;

          if (!data.transform2) return;

          this.transformTimeout2 = setTimeout(() => {
            this.image.style.transitionDuration = data.duration2 ? data.duration2 + 'ms' : '';
            this.image.style.transform = data.transform2;

            if (!data.transform3) return;

            this.transformTimeout3 = setTimeout(() => {
              this.image.style.transitionDuration = data.duration3 ? data.duration3 + 'ms' : '';
              this.image.style.transform = data.transform3;
            }, data.duration2 || this.defaultDuration);
          }, data.duration1 || this.defaultDuration);
        }
      }
    }

    /**
     * @TODO: writeup description
     */
    setHeight() {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(
            function (entry) {
              if (entry.isIntersecting) {
                this.loadPage(Number(entry.target.dataset.position));
              }
            }.bind(this)
          );
        },
        {
          threshold: 0.5,
        }
      );

      const screens = this.sliderItemsToShow.length + 2;

      for (let i = 1; i < screens; i++) {
        let marker = document.createElement('div');

        // For debugging
        marker.classList.add('product-highlight-marker', 'tw-relative', 'tw-pointer-events-none');

        // First page
        if (i === screens) {
          marker.classList.add('tw-h-screen-half', 'tw-bg-accent', 'tw-opacity-20');
        } else {
          marker.classList.add('tw-h-screen');
        }

        marker.classList.add('tw-hidden', 'md:tw-block', 'tw-pointer-events-none');
        marker.dataset.position = i;
        marker.innerHTML = '<span />';
        this.container.append(marker);
        observer.observe(marker);
      }
    }
  }

  customElements.define('product-highlights', ProductHighlights);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rod-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-seeker"] && !Shopify.designMode) return;
  try {
    
  class VideoSeeker extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.currentTime = 0;
      this.markers = [];
      this.currentMarker = null;
      this.timeout = null;
      this.pi = Math.PI;
      this.t = 0;
      this.activeButton = null;

      this.audioToggleButton = this.querySelector('button.audio-toggle');
      this.muted = false;

      this.audioToggleButton.addEventListener('click', () => {
        if (this.muted) {
          this.unmute();
        } else {
          this.mute();
        }
        this.muted = !this.muted;
      });

      // Set description height on load and on window resize
      /*
      this.setDescriptionHeight();
      window.addEventListener('resize', () => {
        this.setDescriptionHeight();
      });
      */

      // Button click handlers
      this.querySelectorAll('button:not(.video-seeker__play-button-overlay)').forEach((button) => {
        this.markers.push(button.dataset.time);
        button.addEventListener('click', this.onButtonClick.bind(this));
      });

      this.querySelector('.video-seeker__play-button-overlay').addEventListener('click', (event) => {
        this.querySelector('.video-seeker__play-button-overlay').style.display = 'none';
        this.video.play();
      });

      // Video paused
      this.video.addEventListener('pause', () => {
        clearTimeout(this.timeout);
      });

      this.video.addEventListener('click', () => {
        this.pause();
      });

      const seekerButtons = document.querySelectorAll('.video-seeker__tabs button');
      const seekerBars = document.querySelectorAll('.video-seeker__tabs .progress-bar');

      var times = [];

      seekerButtons.forEach((element) => {
        times.push(element.dataset.time);
      });

      this.video.addEventListener('timeupdate', () => {
        const roundedTime = Math.floor(this.video.currentTime * 10) / 10;
        const active = Math.max.apply(
          null,
          this.markers.filter(function (v, i) {
            return v <= roundedTime;
          })
        );
        this.activeIndex = this.markers.findIndex((time) => time == active);
        this.activeButton = document.querySelector(`[data-time="${active}"]`);

        times.forEach((time, idx) => {
          const nextValue = idx == this.markers.length - 2 ? Math.floor(this.video.duration) : this.markers[idx + 2];

          if (roundedTime > time) {
            if (roundedTime > nextValue) {
              seekerBars[idx].style.width = '100%';
            } else {
              const percentage = Math.min(((roundedTime - time) / (nextValue - time)) * 100, 100);

              seekerBars[idx].style.width = `${percentage}%`;
            }
          } else {
            seekerBars[idx].style.width = '0%';
          }
        });

        // Update current time
        if (roundedTime !== this.currentTime) {
          this.currentTime = roundedTime;
        }
      });

      // Video time update
      /*
      this.video.addEventListener('timeupdate', () => {
        // const roundedTime = Math.floor(this.video.currentTime);
        const roundedTime = Math.floor(this.video.currentTime * 10) / 10;
        const active = Math.max.apply(
          null,
          this.markers.filter(function (v, i) {
            return v <= roundedTime;
          })
        );
        this.activeIndex = this.markers.findIndex((time) => time == active);
        this.activeButton = document.querySelector(`[data-time="${active}"]`);

        // Marker update
        if (active !== this.currentMarker) {
          this.swapDescription(this.activeIndex);

          // Calculate next value
          const nextValue =
            this.activeIndex == this.markers.length - 1
              ? Math.floor(this.video.duration)
              : this.markers[this.activeIndex + 1];

          // Reset timeout position value
          this.alpha = 0;

          // Calculate timeout speed
          this.t = ((nextValue - active) * 1000) / 360;

          // Remove active states
          document.querySelectorAll('[data-time] > .dot.--active').forEach((dot) => dot.classList.remove('--active'));
          document.querySelectorAll('.dot-path').forEach((path) => path.setAttribute('d', ''));

          // Set new active state
          this.currentMarker = active;
          this.activeButton.querySelector('.dot').classList.add('--active');

          // Trigger animation timeout
          this.drawCircle(this.activeButton);
        }

        // Update current time
        if (roundedTime !== this.currentTime) {
          this.currentTime = roundedTime;
        }
      });
      */

      // On intersect, enable autoplay
      /*
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            this.video.play();
            observer.disconnect();
          }
        }.bind(this), { threshold: 1 });
      });
      observer.observe(this.video);
      */
    }

    drawCircle(button) {
      this.alpha++;
      var r = (this.alpha * this.pi) / 180,
        x = Math.sin(r) * 125,
        y = Math.cos(r) * -125,
        mid = this.alpha > 180 ? 1 : 0,
        anim = 'M 0 0 v -125 A 125 125 1 ' + mid + ' 1 ' + x + ' ' + y + ' z';
      button.querySelector('.dot-path').setAttribute('d', anim);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(
        function () {
          this.drawCircle(button);
        }.bind(this),
        this.t
      );
    }

    resetSegment() {
      // Reset timeout position value
      this.alpha = 0;
      clearTimeout(this.timeout);
      // this.drawCircle(this.activeButton);
    }

    onButtonClick(event) {
      event.preventDefault();
      this.querySelector('.video-seeker__play-button-overlay').style.display = 'none';
      this.video.currentTime = Number(event.currentTarget.dataset.time);
      this.video.play();
      this.resetSegment();
    }

    swapDescription(activeIndex) {
      const classHide = ['tw-invisible', 'tw-absolute'];

      this.querySelectorAll('.video-slide-description').forEach((description, index) => {
        if (index + 1 === activeIndex) {
          description.classList.remove(...classHide);
        } else {
          description.classList.add(...classHide);
        }
      });
    }

    setDescriptionHeight() {
      const descriptionWrapper = this.querySelector('.section-descriptions');
      const descriptions = descriptionWrapper.querySelectorAll('.video-slide-description');
      let tallest = 0;
      descriptions.forEach((description) => {
        if (description.offsetHeight > tallest) {
          tallest = description.offsetHeight;
        }
      });
      descriptionWrapper.style.height = `${tallest}px`;
    }

    pause() {
      this.querySelector('.video-seeker__play-button-overlay').style.display = 'block';
      this.video.pause();
    }

    mute() {
      this.audioToggleButton.classList.add('audio-toggle--muted');
      this.audioToggleButton.setAttribute('aria-label', 'Unmute audio');
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
      });
    }

    unmute() {
      this.audioToggleButton.classList.remove('audio-toggle--muted');
      this.audioToggleButton.setAttribute('aria-label', 'Mute audio');
      this.querySelectorAll('video').forEach((video) => {
        video.muted = false;
      });
    }
  }

  customElements.define('video-seeker', VideoSeeker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-simple"] && !Shopify.designMode) return;
  try {
    
  class VideoSimple extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.timeout = null;
      this.activeButton = null;

      this.audioToggleButton = this.querySelector('button.audio-toggle');
      this.muted = false;

      this.audioToggleButton.addEventListener('click', () => {
        if (this.muted) {
          this.unmute();
        } else {
          this.mute();
        }
        this.muted = !this.muted;
      });

      this.querySelector('.video-seeker__play-button-overlay').addEventListener('click', (event) => {
        this.querySelector('.video-seeker__play-button-overlay').style.display = 'none';
        this.video.play();
      });

      // Video paused
      this.video.addEventListener('pause', () => {
        clearTimeout(this.timeout);
      });

      this.video.addEventListener('click', () => {
        this.pause();
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      this.querySelector('.video-seeker__play-button-overlay').style.display = 'none';
      this.video.play();
    }

    pause() {
      this.querySelector('.video-seeker__play-button-overlay').style.display = 'block';
      this.video.pause();
    }

    mute() {
      this.audioToggleButton.classList.add('audio-toggle--muted');
      this.audioToggleButton.setAttribute('aria-label', 'Unmute audio');
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
      });
    }

    unmute() {
      this.audioToggleButton.classList.remove('audio-toggle--muted');
      this.audioToggleButton.setAttribute('aria-label', 'Mute audio');
      this.querySelectorAll('video').forEach((video) => {
        video.muted = false;
      });
    }
  }

  customElements.define('video-simple', VideoSimple);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  class VideoSlider extends SlideshowComponent {
    /**
     * Define custom slide/fade timeout variables
     */
    constructor() {
      super();

      this.slideTimeout = null;
      this.slideSpeed = 100;

      this.fadeTimeout = null;
      this.fadeSpeed = 100;

      this.counterActiveClass = '--active';

      this.querySelectorAll('video').forEach((video) => {
        video.onended = function () {
          // Next video
          if (this.autoplayButtonIsSetToPlay) {
            this.querySelector('.slider-button--next').dispatchEvent(new Event('click'));
          }
        }.bind(this);
      });

      this.audioToggleButton = this.querySelector('button.audio-toggle');
      this.muted = true;

      this.audioToggleButton.addEventListener('click', () => {
        if (this.muted) {
          this.unmute();
        } else {
          this.mute();
        }
        this.muted = !this.muted;
      });
    }

    update() {
      super.update();
      if (this.enableSliderLooping) {
        this.prevButton.removeAttribute('disabled');
        this.nextButton.removeAttribute('disabled');
      }
    }

    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }

    play() {
      this.slider.setAttribute('aria-live', 'off');
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      this.getCurrentVideo().play();
      this.updateProgressBar();
    }

    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      cancelAnimationFrame(this.animationId);
      this.getCurrentVideo().pause();
    }

    mute() {
      this.audioToggleButton.classList.add('audio-toggle--muted');
      this.audioToggleButton.setAttribute('aria-label', 'Unmute audio');
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
      });
    }

    unmute() {
      this.audioToggleButton.classList.remove('audio-toggle--muted');
      this.audioToggleButton.setAttribute('aria-label', 'Mute audio');
      this.querySelectorAll('video').forEach((video) => {
        video.muted = false;
      });
    }

    /**
     * Adds fade delay to slide event
     */
    linkToSlide(event) {
      event.preventDefault();

      const index = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;

      if (index == this.currentPage || index < 1 || index > this.sliderItemsToShow.length) {
        // No need to scroll
        return;
      }

      this.loadSlide(index);
    }

    /**
     * New function to load target by index
     */
    loadSlide(index) {
      // Clear timeouts
      clearTimeout(this.slideTimeout);
      clearTimeout(this.fadeTimeout);

      // Determine target scroll position
      const slideScrollPosition = this.sliderFirstItemNode.clientWidth * (index - 1);

      // Fade to 0% opacity
      this.slider.classList.add('tw-opacity-0');

      // Slide to target position
      this.slideTimeout = setTimeout(
        function () {
          this.pause();

          this.slider.scrollTo({
            left: slideScrollPosition,
          });

          // Fade back to 100% opacity
          this.fadeTimeout = setTimeout(
            function () {
              this.pause();
              this.getCurrentVideo().currentTime = 0;
              if (!this.autoplayButtonIsSetToPlay) {
                this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
                this.autoplayButtonIsSetToPlay = true;
              }
              this.play();
              this.slider.classList.remove('tw-opacity-0');
            }.bind(this),
            this.fadeSpeed
          );
        }.bind(this),
        this.slideSpeed
      );
    }

    onButtonClick(event) {
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
      const step = Number(event.currentTarget.dataset.step) || 1;
      let index;

      if (isFirstSlide && event.currentTarget.name === 'previous') {
        index = this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        index = 0;
      } else {
        index = this.currentPage + step;
      }

      this.loadSlide(index);
    }

    getCurrentVideo() {
      const currentPage = this.currentPage || 1;
      return this.querySelectorAll('video')[currentPage - 1];
    }

    updateProgressBar() {
      const video = this.getCurrentVideo();
      const progressBar = document.querySelector(`#progress-${video.dataset.index}`);
      const currentTime = video.currentTime;

      if (!video.duration) {
        this.animationId = requestAnimationFrame(this.updateProgressBar.bind(this));
      }

      if (currentTime <= video.duration) {
        const progressBarWidth = video.clientWidth * (currentTime / video.duration);
        progressBar.style.transform = `translateX(${progressBarWidth}px)`;
        this.animationId = requestAnimationFrame(this.updateProgressBar.bind(this));
      }
    }
  }

  customElements.define('video-slider', VideoSlider);

  } catch(e) { console.error(e); }
})();
})();
